export class TimelineSectionStudentInfo {
    studentFullName: string;
    studentId: number;

    constructor(studentId: number, studentFullName: string) {
        this.studentId = studentId;
        this.studentFullName = studentFullName;
    }
}